import React from "react";

import { FooterContainer, FooterText } from "../styled-components/footerstyle"

const Footer = () => {
  return (
    <FooterContainer>
      <FooterText>Sofia Ringstedt</FooterText>
    </FooterContainer>
  )
}

export default Footer;